module.exports = __webpack_public_path__ + "static/media/icon-unpublish.de3abbb3.svg";